import { RootState } from '..'

import { FactorRequestState } from './slice'

export const selectSupplierFactorRequests = (
  state: RootState,
): FactorRequestState['supplierRequests'] => state.factorRequests.supplierRequests
